import { useAuth } from '@src/@data/store/AuthProvider';
import { useCompanies } from '@src/@data/store/CompaniesProvider';
import { RouteComponentProps, Redirect } from 'react-router-dom';
import {
  ROUTE_AUTH_SIGN_IN,
  getPath,
  ROUTE_COMPANIES_CREATE,
  ROUTE_COMPANY_OVERVIEW,
} from './consts';
import { RouteEntry } from './routeEntries';

/**
 ** Final Route Component Checks for Login & User Role and then redirects to the route
 */
export const FinalRoute: React.FC<RouteComponentProps & { route: RouteEntry }> =
  (props) => {
    const { route } = props;
    const { user } = useAuth();
    const { companies } = useCompanies();

    // if user is not logged in and there is not in auth or public route
    if (
      (!user && route.meta === undefined) ||
      (!user && route.meta && !route.meta.authRoute && !route.meta.publicRoute)
    ) {
      return <Redirect to={ROUTE_AUTH_SIGN_IN} />;
    }

    // if user has finished logging in
    if (user && companies && route.meta && route.meta.authRoute) {
      if (companies.length === 0) {
        return <Redirect to={getPath(ROUTE_COMPANIES_CREATE)} />;
      } else {
        return (
          <Redirect
            to={getPath(ROUTE_COMPANY_OVERVIEW, {
              companyId: companies[0].id,
            })}
          />
        );
      }
    }

    // if user is trying to navigate but has no companies
    if (
      user &&
      companies &&
      companies.length === 0 &&
      route.meta &&
      !route.meta.companyCreateRoute
    ) {
      return <Redirect to={getPath(ROUTE_COMPANIES_CREATE)} />;
    }

    return <route.component {...props} />;
  };
